import { h } from 'preact'
import UserAvatar from '../User/UserAvatar'
import Tooltip from '../ui-components/Tooltip'

export type votedUserType = {
  avatar: string,
  id: number,
  name: string,
  url: string
}

interface Props {
  votedUsers: Array<votedUserType>,
  previewCount: number,
  isCurrentUserVoted: boolean
}

const VotedUsers = ({ votedUsers, previewCount, isCurrentUserVoted }: Props) => (
  <div className='topic-voted-users m-v'>
    <Tooltip
      withArrow
      trigger={(
        <div>
          {
            votedUsers.slice(0, previewCount).map(user => (
              <UserAvatar
                disablePopup
                user={user}
                extraClass='avatar avatar--S'
                showRank={false}
              />
            ))
          }
          {
            votedUsers.length - previewCount > 0 ? (
              <span className='text--meta'>+{ votedUsers.length - previewCount }</span>
            ) : null
          }
        </div>
      )}
      tooltipMessage={(
        <ul className='post-like-list__complete-list'>
          {
            votedUsers.map(votedUser => (
              <li className='post-like-list__item'>
                <a className='link' href={votedUser.url}>
                  <UserAvatar
                    user={votedUser}
                    extraClass='avatar avatar--S'
                    disablePopup
                    showRank={false}
                  />
                  <span>{votedUser.name}</span>
                </a>
              </li>
            ))
          }
        </ul>
      )}
    />
  </div>
)

export default VotedUsers
